import * as React from 'react';

import type {GetEditionEngagementStats_edition_comparison} from 'nutshell-graphql-types';

import {WinnerBadge} from '../../editions/a-b-testing/winner-badge';

import styles from './comparison-engagement-block-header.module.css';

type Props = {
    comparison: GetEditionEngagementStats_edition_comparison;
    versionId: string;
    text: string;
};

export function ComparisonEngagementBlockHeader(props: Props) {
    const isTied = props.comparison.isTied && !props.comparison.winnerEdition;
    const isWinningEdition =
        props.comparison.winningEdition && props.comparison.winningEdition.id === props.versionId;
    const isWinning = !isTied && isWinningEdition;

    return (
        <div className={styles.header}>
            {props.text}
            {isWinning ? <WinnerBadge isWinner={Boolean(props.comparison.winnerEdition)} /> : ''}
        </div>
    );
}
